import React, { createContext, useEffect, useState } from 'react'
import WordReadability from './WordReadability'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { queryClient as qc } from 'keys'
import { getCategoriesFetch } from 'store/middlewares/assessment.crud'
import { wordReadabilityHooks } from '.'

const WordReadabilityPage = (props) => {
    const columns = wordReadabilityHooks.useColumns()
    const queryClient = useQueryClient()
    const [dynamicColumns, setDynamicColumns] = useState(null)

    const categories = useQuery({
        queryKey: [qc.categories],
        queryFn: async () => {
            if (!dynamicColumns) {
                const { data } = await getCategoriesFetch()
                let nColumns = [...columns]
                data.forEach(category => {
                    nColumns.push({
                        accessorKey: category.name,
                        header: category.label || category.name,
                        alignCenter: true
                    })
                });
                setDynamicColumns(nColumns)
                return data
            }
        },
        refetchOnWindowFocus: false
    })

    const commonValue = {
        categories: categories.data,
        dynamicColumns: dynamicColumns || []
    }

    useEffect(() => {
        return (() => {
            queryClient.removeQueries([qc.wordDefFrequency])
        })
    }, [])

    return (
        <WordReadabilityContext.Provider value={commonValue}>
            <WordReadability />
        </WordReadabilityContext.Provider>
    )

}
export const WordReadabilityContext = createContext()
export default WordReadabilityPage